export { default } from "./AssessmentResults.gql";
